// startupAnns.config.ts

export type StartupAnnId =
    | "referral-rewards-doubled"
    | "referral-rewards-doubled-v2"
    | "holidayCashback"
    | "mw-free-coins"
    | "merry-christmas"
    | "earn-016-wld"
    | "earn-034-wld";

export type Lang = "en" | "es" | "id" | "pt-br" | "th";

export interface BaseStartupAnnConfig {
    id: StartupAnnId;
    enabled: boolean; // <--- your "active-var" per campaign
    startAt: number; // timestamp (ms)
    endAt: number; // timestamp (ms)
    maxImpressionsPerUser: number;
    /**
     * Map of locale -> image URL.
     * Example keys: "en", "es", "id", "pt-br", "th".
     */
    imageUrls: Partial<Record<Lang, string>> & Record<string, string>;
}

export interface WeightedStartupAnnConfig extends BaseStartupAnnConfig {
    mode: "weighted";
    weight: number; // for random pick
}

export interface UrlForcedStartupAnnConfig extends BaseStartupAnnConfig {
    mode: "url-forced";
    trigger: {
        param: string;
        value: string;
    };
}

export type StartupAnnConfig =
    | WeightedStartupAnnConfig
    | UrlForcedStartupAnnConfig;

export const STARTUP_ANNS_ENABLED = true;

export const startupAnns: StartupAnnConfig[] = [
    {
        mode: "weighted",
        id: "referral-rewards-doubled",
        enabled: true,
        weight: 5,
        startAt: Date.UTC(2025, 10, 28),
        endAt: Date.UTC(2025, 11, 15),
        maxImpressionsPerUser: 14,
        imageUrls: {
            en: "https://media.bridge.cm/startup-anns/referral-double/referral-double-en.png",
            es: "https://media.bridge.cm/startup-anns/referral-double/referral-double-es.png",
            id: "https://media.bridge.cm/startup-anns/referral-double/referral-double-id.png",
            "pt-br":
                "https://media.bridge.cm/startup-anns/referral-double/referral-double-ptbr.png",
            th: "https://media.bridge.cm/startup-anns/referral-double/referral-double-th.png",
        },
    },
    {
        mode: "weighted",
        id: "referral-rewards-doubled-v2",
        enabled: true,
        weight: 6,
        startAt: Date.UTC(2025, 11, 19),
        endAt: Date.UTC(2025, 11, 29),
        maxImpressionsPerUser: 28,
        imageUrls: {
            en: "https://media.bridge.cm/startup-anns/referral-double-v2/referral-double-v2-en.png",
            es: "https://media.bridge.cm/startup-anns/referral-double-v2/referral-double-v2-es.png",
            id: "https://media.bridge.cm/startup-anns/referral-double-v2/referral-double-v2-id.png",
            "pt-br":
                "https://media.bridge.cm/startup-anns/referral-double-v2/referral-double-v2-ptbr.png",
            th: "https://media.bridge.cm/startup-anns/referral-double-v2/referral-double-v2-th.png",
        },
    },
    {
        mode: "weighted",
        id: "merry-christmas",
        enabled: true,
        weight: 5,
        startAt: Date.UTC(2025, 11, 24),
        endAt: Date.UTC(2025, 12, 26),
        maxImpressionsPerUser: 1,
        imageUrls: {
            en: "https://media.bridge.cm/startup-anns/merry-christmas/merry-christmas.png",
            es: "https://media.bridge.cm/startup-anns/merry-christmas/merry-christmas.png",
            id: "https://media.bridge.cm/startup-anns/merry-christmas/merry-christmas.png",
            "pt-br":
                "https://media.bridge.cm/startup-anns/merry-christmas/merry-christmas.png",
            th: "https://media.bridge.cm/startup-anns/merry-christmas/merry-christmas.png",
        },
    },
    {
        mode: "weighted",
        id: "earn-034-wld",
        enabled: true,
        weight: 5,
        startAt: Date.now() - 24 * 60 * 60 * 1000,
        endAt: Date.UTC(2025, 11, 29),
        maxImpressionsPerUser: 3,
        imageUrls: {
            en: "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-en.webp",
            es: "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-es.webp",
            id: "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-id.webp",
            "pt-br":
                "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-ptbr.webp",
            th: "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-th.webp",
        },
    },
    {
        mode: "url-forced",
        id: "earn-016-wld",
        enabled: true,
        trigger: {
            param: "sd",
            value: "e016w",
        },
        startAt: Date.now() - 24 * 60 * 60 * 1000,
        endAt: Date.UTC(2026, 0, 1),
        maxImpressionsPerUser: 2,
        imageUrls: {
            en: "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-en.webp",
            es: "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-es.webp",
            id: "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-id.webp",
            "pt-br":
                "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-ptbr.webp",
            th: "https://media.bridge.cm/startup-anns/earn-034-wld/earn-034-wld-th.webp",
        },
    },
    {
        mode: "url-forced",
        id: "mw-free-coins",
        enabled: true,
        trigger: {
            param: "sd",
            value: "mwfc",
        },
        startAt: Date.now() - 24 * 60 * 60 * 1000,
        endAt: Date.UTC(2026, 0, 1),
        maxImpressionsPerUser: 2,
        imageUrls: {
            en: "https://media.bridge.cm/startup-anns/mw-free-coins/mw-fc-en.png",
            es: "https://media.bridge.cm/startup-anns/mw-free-coins/mw-fc-es.png",
            id: "https://media.bridge.cm/startup-anns/mw-free-coins/mw-fc-id.png",
            "pt-br":
                "https://media.bridge.cm/startup-anns/mw-free-coins/mw-fc-ptbr.png",
            th: "https://media.bridge.cm/startup-anns/mw-free-coins/mw-fc-th.png",
        },
    },
];
